import { NgbDateStruct } from "@ng-bootstrap/ng-bootstrap";

export namespace Participants {
    export function sortOptions(): Array<{ key: string, value: string }> {
        const options = new Array<{ key: string, value: string }>();
        options.push({ key: "A", value: "Alphabetical" });
        options.push({ key: "C", value: "Completion %" });
        options.push({ key: "D", value: "Submission Date" });
        return options;
    }

    export module Organizations {
        export interface IOrganization {
            organizationId: number;
            organizationName: string;
            organizationTin: string;
            clientId: number;
            clientName: string;
            clientTin: string;
            assignedContractTags: string;
            noOfPractices: number;
            noOfProviders: number;
            noOfPatients: number;
            completedMeasures: number;
            totalMeasures: number;
            status: boolean;
            measureCompletion: number;
            submissionDate?: Date;
            totalItems: number;
        }

        export class Filters {
            userId: number = null;
            clientId?: number = null;
            roleId: number = null;
            encryptedClientId = "";
            organizationId?: number = null;
            contractId?: number = null;
            federalTaxId = "";
            completion?: boolean = null;
            date?: NgbDateStruct = null;
            submissionDate = "";
          sortBy = "A";
          listTypeId: number = null;
        }
    }

    export module Practices {
        export interface IPractice {
            practiceId: number;
            practiceName: string;
            practiceNpi: string;
            organizationId: number;
            organizationName: string;
            organizationTin: string;
            clientId: number;
            clientName: string;
            clientTin: string;
            assignedContractTags: string;
            noOfProviders: number;
            noOfPatients: number;
            completedMeasures: number;
            totalMeasures: number;
            status: boolean;
            submissionDate?: Date;
            totalItems: number;
        }

        export class Filters {
            userId: number = null;
            activeTab: number = null;
            encryptedUserId = "";
            clientId?: number = null;
            roleId: number = null;
            organizationId?: number = null;
            encryptedOrganizationId = "";
            practiceId?: number = null;
            contractId?: number = null;
            practiceNpi = "";
            completion?: boolean = null;
            date?: NgbDateStruct;
            submissionDate = "";
          sortBy = "A";
          listTypeId: number = null;
        }
    }

    export module Providers {
        export interface IProvider {
            providerId: number;
            providerName: string;
            providerNpi: string;
            practiceId: number;
            practiceName: string;
            practiceNpi: string;
            organizationId: number;
            organizationName: string;
            organizationTin: string;
            clientId: number;
            clientName: string;
            clientTin: string;
            assignedContractTags: string;
            noOfPatients: number;
            completedMeasures: number;
            totalMeasures: number;
            status: boolean;
            measureCompletion: number;
            submissionDate?: Date;
            totalItems: number;
        }

        export class Filters {
            activeTab: number = 0;
            userId: number = null;
            roleId: number = null;
            encryptedUserId = "";
            clientId?: number;
            organizationId?: number;
            practiceId?: number;
            encryptedPracticeId = "";
            encryptedOrganizationId = "";
            encryptedClientId = "";
            providerId?: number;
            contractId?: number;
            providerNpi = "";
            loggedUserId: number;
            loggedClientId?: number;
            loggedRoleId: number;
            completion?: boolean;
            date?: NgbDateStruct;
            submissionDate = "";
            sortBy = "A";
            mrn = "";
            measureName = "";
            measureId: number;
            source = "";
            patientName = "";
          filterUserId: number;
          listTypeId: number;
        }
    }

    export module Patients {
        export interface IPatient {
            patientId: number;
            patientName: string;
            mrn: string;
            dateOfBirth?: Date;
            dateOfService: string;
            providerId: number;
            providerName: string;
            providerNpi: string;
            practiceId: number;
            practiceName: string;
            practiceNpi: string;
            organizationId: number;
            organizationName: string;
            organizationTin: string;
            clientId: number;
            clientName: string;
            clientTin: string;
            assignedContractTags: string;
            assignedContractIds: string;
            statusName: string;
            measureCode: string;
            measureName: string;
            measureId: number;
            completedMeasures: number;
            totalMeasures: number;
            status: boolean;
            exclusions: number;
            riskScore: number;
            measureCompletion: number;
            measurePerformance: number;
            totalItems: number;
            currentItems: number;
            appointmentId: number;
            inRuleId: string;
            comments: string;
            InRuleId: string;
            contractId: number;
            hide: boolean;
            contractName: string;
            templateTag: string;
            processedDate: string;
            appointmentCount: number;
            isExpanded: boolean;
            patientDetails?: Array<Participants.Patients.IPatient>;
        }

        export interface IPatientMeasure {
            appointmentId: number;
            patientId: number;
            reportingYear: string;
            measureId: number;
            measureName: string;
            measureIdentifier: string;
            programs: string;
            programIds: string;
            status: string;
            measureCompletion: boolean;
            dateOfService: string;
            providerId: number;
            providerName: string;
            providerNpi: string;
            practiceId: number;
            practiceName: string;
            practiceNpi: string;
            totalItems: number;
            collapsed: boolean;
            show: boolean;
            active: boolean;
            inRuleId: string;
            flag: boolean;
            contractId: number;
        }

        export class Filters {
            userId: number = null;
            roleId: number = null;
            activeTab: number = null;
            tabType: string = null;
            clientId?: number = null;
            encryptedClientId = "";
            encryptedOrganizationId = "";
            organizationId?: number = null;
            contractId?: number = null;
            practiceId?: number = null;
            providerId?: number = null;
            encryptedPracticeId = "";
            encryptedProviderId = "";
            patientName = "";
            programId?: number = null;
            statusId?: number = null;
            completion?: boolean = null;
            measureName: string;
            measureCode: string;
            mrn = "";
           sortBy = "A";
           listTypeId: number = null;
        }

        export class MeasuresFilters {
            measureName = "";
            reportingYear = "";
            contractId?: number = null;
        }
    }
}
